import React, {useRef, useState} from "react";
import {TableCell, TableRow} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import ProjectDetailRowAccordionSummary from "./ProjectDetailRowAccordionSummary";
import ProjectDetailRowItemAccordionDetails from "./ProjectDetailRowItemAccordionDetails";
import ProjectDetailRowGroupAccordionDetails from "./ProjectDetailRowGroupAccordionDetails";

function ProjectDetailRow({
                            quoteDetailId,
                            isUpdate,
                            activeForm,
                            setActiveForm,
                            activeQuoteDetail,
                            handleDetailChange,
                            productItems, 
                            productItemIds, 
                            productGroups, 
                            productGroupIds,
                            productsStatus,
                            quoteTemplates,
                            quoteTemplatesStatus,
                            isSubmitting,
                            handleProductAddToQuote,
                            allQuoteDetailsSaved,
                            setAllQuoteDetailsSaved
})
{
    const [expanded, setExpanded] = useState(!!isUpdate);
    const [savedQuoteDetail, setSavedQuoteDetail] = useState(activeQuoteDetail);
    const [initialTemplateQuoteDetail, setInitialTemplateQuoteDetail] = useState();
    const [draftQuoteDetail, setDraftQuoteDetail] = useState(activeQuoteDetail);
    
    const handleProductRemoveFromQuote = (quoteDetailId) => {
        setActiveForm(prevState => {
            const updatedQuoteDetails = 
                isUpdate
                    ? prevState.quoteDetails.filter(detail => detail.id !== quoteDetailId) 
                    : prevState.quoteDetails.filter(detail => detail.tempId !== quoteDetailId);
            return { ...prevState, quoteDetails: updatedQuoteDetails };
        });

        setAllQuoteDetailsSaved(prevState => {
            const newState = { ...prevState };
            delete newState[quoteDetailId];
            return newState;
        })
    };
    
    const formValidQuoteDetail = useRef({
        id: !!isUpdate,
    });

    return (
        <TableRow key={quoteDetailId}>
            <TableCell sx={{ p: 0 }}>
                <Accordion
                    expanded={!!expanded}
                    onChange={(event, newExpanded) => {setExpanded(newExpanded)}}
                    sx={{ boxShadow: 'none' }}
                >
                    <ProjectDetailRowAccordionSummary
                        quoteDetailId={quoteDetailId}
                        productGroups={productGroups}
                        productItems={productItems}
                        productGroupIds={productGroupIds}
                        productItemIds={productItemIds}
                        isSubmitting={isSubmitting}
                        quoteTemplates={quoteTemplates}
                        quoteTemplatesStatus={quoteTemplatesStatus}
                        productsStatus={productsStatus}
                        onChange={isValid => (formValidQuoteDetail.current.id = isValid)}
                        setExpanded={setExpanded}
                        setInitialTemplateQuoteDetail={setInitialTemplateQuoteDetail}
                        allQuoteDetailsSaved={allQuoteDetailsSaved}
                        draftQuoteDetail={draftQuoteDetail}
                        setDraftQuoteDetail={setDraftQuoteDetail}
                        formValidQuoteDetail={formValidQuoteDetail}
                        handleProductRemoveFromQuote={handleProductRemoveFromQuote}
                    />
                    { ( draftQuoteDetail.productItemId &&
                        <ProjectDetailRowItemAccordionDetails
                            quoteDetailId={quoteDetailId}
                            handleDetailChange={handleDetailChange}
                            productItem={productItems[draftQuoteDetail.productItemId]}
                            isSubmitting={isSubmitting}
                            setExpanded={setExpanded}
                            savedQuoteDetail={savedQuoteDetail}
                            setSavedQuoteDetail={setSavedQuoteDetail}
                            initialTemplateQuoteDetail={initialTemplateQuoteDetail}
                            allQuoteDetailsSaved={allQuoteDetailsSaved}
                            setAllQuoteDetailsSaved={setAllQuoteDetailsSaved}
                            draftQuoteDetail={draftQuoteDetail}
                            setDraftQuoteDetail={setDraftQuoteDetail}
                            formValidQuoteDetail={formValidQuoteDetail}
                            quoteTemplates={quoteTemplates}
                            activeForm={activeForm}
                            isUpdate={isUpdate}
                        /> )
                        ||  (draftQuoteDetail.productGroupId &&
                        <ProjectDetailRowGroupAccordionDetails
                            quoteDetailId={quoteDetailId}
                            activeQuoteDetail={activeQuoteDetail}
                            handleDetailChange={handleDetailChange}
                            productGroup={productGroups[draftQuoteDetail.productGroupId]}
                            isSubmitting={isSubmitting}
                            handleProductAddToQuote={handleProductAddToQuote}
                            activeForm={activeForm}
                            setExpanded={setExpanded}
                            isUpdate={isUpdate}
                            initialTemplateQuoteDetail={initialTemplateQuoteDetail}
                            draftQuoteDetail={draftQuoteDetail}
                            setDraftQuoteDetail={setDraftQuoteDetail}
                            formValidQuoteDetail={formValidQuoteDetail}
                            savedQuoteDetail={savedQuoteDetail}
                            setSavedQuoteDetail={setSavedQuoteDetail}
                            setAllQuoteDetailsSaved={setAllQuoteDetailsSaved}
                            quoteTemplates={quoteTemplates}
                        /> )
                    }
                </Accordion>
            </TableCell>
        </TableRow>
    );
}

export default ProjectDetailRow;